import React from 'react';
import { css } from '@emotion/css';

import { useTranslation } from '@lyearn/i18n';
import UserFilter from '@/components/Form/components/Conditions/components/FilterValues/UserFilter';
import { useUserContext } from '@/modules/auth/hooks/useUser';

interface Props {
  error?: boolean;
  value: string[];
  groupIds?: string[];
  onChange: (value: string[]) => void;
  placeholder?: string;
  disabled?: boolean;
}

const listBoxStyle = css`
  height: 218px;
  padding: 8px;
`;

const ParticipantSelection = (props: Props) => {
  const { t } = useTranslation();
  const {
    groupIds,
    value,
    onChange,
    error,
    placeholder = t('1on1s:Modal.SetupMeetingUserFieldPlaceholder'),
    disabled,
  } = props;
  const currentUser = useUserContext();
  const onFilterValueChange = React.useCallback(
    (userId?: string) => {
      if (userId) {
        onChange([userId]);
      }
    },
    [onChange],
  );

  return (
    <UserFilter
      showEmail
      className="w-full"
      classes={{
        listbox: listBoxStyle,
      }}
      clearOnBlur={false}
      disabled={disabled}
      error={error}
      excludeUsers={[currentUser.id]}
      filterValue={value[0]}
      groupIds={groupIds}
      placeholder={placeholder}
      size="large"
      onFilterValueChange={onFilterValueChange}
    />
  );
};

export default React.memo(ParticipantSelection);
